module.exports = {"outlet":"Station"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en_sentinel/royalty.php
// module id = /SN4
// module chunks = 50